module.exports = __webpack_public_path__ + "media/images/web/landings/teachers/s6-869cb1cad519d5c5b7469e737ec8e55d.jpg";